import React from "react";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import RegisterForm from "../components/RegisterForm/RegisterForm";

const Register = () => {
    return (
        <>
            <Navbar />
            <RegisterForm />
            <Footer />
        </>
    )
}

export default Register;
